import axios from "axios";
import $socket from "@/plugins/socket-instance";
import vuetify from "@/plugins/vuetify";
import { getField, updateField } from "vuex-map-fields";

export default {
  namespaced: true,
  state: {
    isAuthInProcess: false,
    isSendingRecoveryMail: false,
    isFetching: false,
    authenticated: false,
    authenticatedUser: {
      active_shop_id: null,
      shop_id: null,
      all_rights: {},
      name: null,
      hash: "dasfasdfdasfa",
      shop: null
    },
    theme: null,
    email: "",
    password: "",
    errorMessage: "",
  },
  getters: {
    getField, //vuex-map-fields
    currentShop(state) {
      return state.authenticatedUser && state.authenticatedUser.shop;
    },
    authenticated(state) {
      return state.authenticated;
    },
    canCurrentUser:
      (state) =>
      /**
       * Возвращает true если текущий авторизованный пользователь имеет право переданное в payload
       *
       * @param {string} payload. Пример payload: 'parts_and_repairtimes|view'
       * @return {boolean}
       */
      (payload) => {
        const availible = {
          full: 2,
          view: 1,
        };
        let arr = payload.split("|");
        let name = arr[0];
        let value = arr[1];
        return (
          state.authenticatedUser &&
          state.authenticatedUser.all_rights[
            state.authenticatedUser.active_shop_id
          ] &&
          state.authenticatedUser.all_rights[
            state.authenticatedUser.active_shop_id
          ][name] >= availible[value]
        );
      },
  },
  mutations: {
    updateField, //vuex-map-fields
    setAuthenticated: (state, payload) => {
      state.authenticated = payload;
      state.password = "";
    },
    setAuthenticatedUser: (state, payload) => {
      state.authenticatedUser = payload;
    },
    setTheme: (state, payload) => {
      state.theme = payload;
      vuetify.framework.theme.dark = payload === "dark" ? true : false;
    },
    setErrorMessage: (state, payload) => {
      state.errorMessage = payload;
    },
  },
  actions: {
    async check({ commit, state, dispatch }) {
      updateField(state, {path: 'isAuthInProcess', value: true});
      return await axios
        .get(this._vm.$apiURL + "/authenticated")
        .then((response) => {
          commit("setAuthenticated", response.data.authenticated || false);
          if (response.data.authenticated === true) {
            commit(
              "setAuthenticatedUser",
              response.data.authenticatedUser || false
            );
            commit(
              "setTheme",
              response.data.authenticatedUser.theme || "light"
            );
            $socket.connect();
            dispatch("telephonies/subscribe", state.authenticatedUser.hash, {
              root: true,
            });
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
          .finally(()=>{
            updateField(state, {path: 'isAuthInProcess', value: false});
          })
    },
    async login({ commit, state, dispatch }) {
      updateField(state, {path: 'isFetching', value: true});
      return await axios
        .post(this._vm.$apiURL + "/login", {
          email: state.email,
          password: state.password,
        })
        .then((response) => {
          updateField(state, {path: 'isFetching', value: false});
          commit("setAuthenticated", response.data.success || false);
          commit("setErrorMessage", response.data.message || "");
        })
        .catch((error) => {
          updateField(state, {path: 'isFetching', value: false});
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async sendRecoveryLink({ commit, state, dispatch }, payload) {
      updateField(state, {path: 'isSendingRecoveryMail', value: true});
      return await axios
        .post(this._vm.$apiURL + "/send-recovery-mail", payload)
        .then((response) => {
          updateField(state, {path: 'isSendingRecoveryMail', value: false});
          if(response.data && response.data.status === "success")
          {
            return response.data;
          }
        })
        .catch((error) => {
          updateField(state, {path: 'isSendingRecoveryMail', value: false});
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async passwordReset({ commit, state, dispatch }, payload) {
      updateField(state, {path: 'isSendingRecoveryMail', value: true});
      return await axios
        .post(this._vm.$apiURL + "/password-reset", payload)
        .then((response) => {
          updateField(state, {path: 'isSendingRecoveryMail', value: false});
          if(response.data && response.data.status === "success")
          {
            return response.data;
          }
        })
        .catch((error) => {
          updateField(state, {path: 'isSendingRecoveryMail', value: false});
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async changeActiveShop({ commit, state, dispatch }, payload) {
      updateField(state, {path: 'isFetching', value: true});
      return await axios
        .post(this._vm.$apiURL + "/users/change-active-shop", {
          shop_id: payload,
        })
        .then((response) => {})
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    logout({ commit, state, dispatch }) {
      return axios
        .get(this._vm.$apiURL + "/logout")
        .then((response) => {
          commit("setAuthenticated", false);
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
  },
};
